
/* User defined models */
import { AppointmentSlot } from './appointmentSlot.model';
import { Candidate } from './candidate.model';
import { Exam } from './exam.model';
import { Hold } from './hold.model';
import { Payment } from './payment.model';
import { Program } from './program.model';
import { State } from './state.model';

export class AppointmentDetail {
  ConfirmationNumber?: string;
  appointmentSlot?: AppointmentSlot;
  payments?: Payment[];
  examName: string;
  status?: string;
  client?: any;
  program?: any;
  candidate?: any;
  exam?: Exam;
  holdId?: string;
  region?: State;
  selectedStartDate?: any;
  selectedEndDate?: any;
  hold?: Hold;
  selected?: boolean;
  id?: string;
  canReschedulePolicy?: boolean;


  constructor(
    program?: Program,
    exam?: Exam,
    candidate?: Candidate,
    ConfirmationNumber?: string,
    status?: string,
    holdId?: string,
    id?: string,
    payments?: Payment[]
  ) {
    this.program = program;
    this.exam = exam;
    this.candidate = candidate;
    this.ConfirmationNumber = ConfirmationNumber;
    this.status = status;
    this.holdId = holdId;
    this.id = id;
    this.payments = payments;

  }
}